module.exports = "/build/web/svg/icon-arrow-right--white.c4554cdae8b4bda6dca659821b53970b.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-arrow-right--white.svg
// module id = 112
// module chunks = 11